import {createSlice} from '@reduxjs/toolkit';
//types
import {IBilingListReducer} from '../../utils/types';
//actions
import {
    getBillingHistoryList
  } from './actions';
//operations
import {
   
    getBillingHistoryListOperation,
    pendingOperation,
    rejectedOperation,
    } from './operations';

export const initialState: IBilingListReducer = {
    billingHistoryData: null,
    isLoading: false,
};

const organizationBillingStore = createSlice({
    name: 'organizationBilling',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBillingHistoryList.pending, pendingOperation);
        builder.addCase(getBillingHistoryList.fulfilled, getBillingHistoryListOperation);
        builder.addCase(getBillingHistoryList.rejected, rejectedOperation);

       
    },
});

export default organizationBillingStore.reducer;
